let accessToken = '';
let refreshInFlight: Promise<boolean> | null = null;

export function setAccessToken(value: string) { accessToken = value; }

async function request(path: string, init: RequestInit = {}) {
  const headers = new Headers(init.headers);
  if (init.body && !headers.has('content-type')) headers.set('content-type', 'application/json');
  headers.set('accept-language', localStorage.getItem('ui-locale') ?? 'en');
  if (accessToken) headers.set('authorization', `Bearer ${accessToken}`);
  const response = await fetch(`/api/v1${path}`, { ...init, headers, credentials: 'include' });
  return { response, data: await response.json().catch(() => null) };
}

async function refreshAccessToken() {
  if (!refreshInFlight) refreshInFlight = (async () => {
    const response = await fetch('/api/v1/auth/refresh', { method: 'POST', headers: { 'accept-language': localStorage.getItem('ui-locale') ?? 'en' }, credentials: 'include' });
    const data = await response.json().catch(() => null);
    if (response.ok && data?.accessToken) { setAccessToken(data.accessToken); return true; }
    setAccessToken(''); window.dispatchEvent(new Event('auth:expired')); return false;
  })().finally(() => { refreshInFlight = null; });
  return refreshInFlight;
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  let result = await request(path, init);
  const canRefresh = !['/auth/login', '/auth/refresh', '/auth/logout'].includes(path);
  if (result.response.status === 401 && canRefresh && await refreshAccessToken()) result = await request(path, init);
  if (!result.response.ok) throw Object.assign(new Error(result.data?.message ?? `HTTP ${result.response.status}`), { code: result.data?.code, status: result.response.status, details: result.data });
  return result.data as T;
}

export const json = (body: unknown) => ({ body: JSON.stringify(body) });
